<div class="edit-poll-option-modal">
    <button
        type="button"
        class="close-btn"
        (click)="close()"
        aria-label="Close"
    >
        <span class="icon-close"></span>
    </button>

    <h4>Edit Selection #{{ data.index + 1 }}</h4>
    <p class="caption-4">
        For best display, keep the selection to 35 characters or fewer. Maximum:
        {{ textMaxLength }}.
    </p>

    <tools-textarea
        class="option-textarea"
        placeholder="Enter poll selection"
        [maxLength]="textMaxLength"
        [singleLine]="true"
        [formControl]="textControl"
    ></tools-textarea>

    <div class="actions">
        <tools-button [variant]="ButtonVariant.OUTLINE" (onClick)="close()">
            Cancel
        </tools-button>
        <tools-button [isDisabled]="textControl.invalid" (onClick)="update()">
            Update Selection
        </tools-button>
    </div>
</div>
